import React from 'react'
import isUndefined from 'lodash/isUndefined'

import SelectField from './SelectField'

class SelectFieldWithAdditions extends React.Component {
  handleItemAddEvent = (e, { value }) => {
    const { maxLength } = this.props
    const strMaxLength = isUndefined(maxLength) ? 20 : maxLength
    const tempVal = value.substring(0, strMaxLength)
    this.props.onItemAdd({ ID: tempVal, Title: tempVal })
  }

  render() {
    const { options, className, name, ...rest } = this.props

    const propsOptions = options.map(({ Title }) => ({ ID: Title, Title }))

    return (
      <SelectField
        name={name}
        className={className}
        allowAdditions
        handleAddition={this.handleItemAddEvent}
        search
        options={propsOptions}
        {...rest}
        additionLabel=""
      />
    )
  }
}

export default SelectFieldWithAdditions
